module.exports = __webpack_public_path__ + "img/Monochrome.495e9a5a.png";